'use client';

import { useCallback } from 'react';
import { Pixum, ImageLoading } from '@pixum/logo';
import { trackEvent, TRACKING_ACTIONS, TRACKING_CATEGORIES, isBrowser } from 'utils';
import { PAGE_PATH } from 'components/constants';

type LogoClickWrapperProps = {
  href: string;
};

export function LogoClickWrapper({ href }: LogoClickWrapperProps) {
  const onLogoClick = useCallback(() => {
    trackEvent(TRACKING_CATEGORIES.HEADER, TRACKING_ACTIONS.LOGO, PAGE_PATH.RootStartPage);

    if (isBrowser()) {
      document.location.href = PAGE_PATH.RootStartPage;
    }
  }, []);

  return (
    <a className="logo-pixum" href={href} onClick={onLogoClick} aria-label="pixum logo">
      <Pixum loading={ImageLoading.Eager} />
    </a>
  );
}
